import { useAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { Address } from '@restworld/utility-types';

import { occupationDataAtom, savedResearchDataAtom } from './save-research-tab.atoms';

export const useSavedResearchProps = () => {
  const { t } = useTranslation('user-settings');
  const [{ data: occupationData }] = useAtom(occupationDataAtom);
  const savedResearch = useAtomValue(savedResearchDataAtom);

  const filterParams = useMemo(() => savedResearch?.filter_params, [savedResearch?.filter_params]);
  const address = useMemo(() => filterParams?.address as Address, [filterParams?.address]);

  const occupationIdsFirstIndex = useMemo(() => {
    const occupationIds = filterParams?.['occupation_id'] as string[];
    const names = occupationIds?.map((id) => occupationData?.find((item) => item.id === Number(id))?.label_it?.label);
    return names?.length ? names[0] : '';
  }, [filterParams, occupationData]);

  return {
    title: occupationIdsFirstIndex
      ? `${occupationIdsFirstIndex}${address ? ` a ${address.locality}` : ''}`
      : `${t('saved_search_title', {
          id: `#${savedResearch.id}`,
        })}`,
    address,
    occupationIdsFirstIndex,
  };
};
